import styled from 'styled-components';

import { CloudUpload } from '@assets/icons/CloudUpload';
import { StyledGapContainer } from '@views/auth/signup/styles';

export const UploadBoxContentAttachment = () => {
  return (
    <StyledUploadButtonContentAttachment>
      <CloudUpload />
      <StyledGapContainer gap={4}>
        <span className='title'>
          Drag and drop files here or click to upload
        </span>
        <span className='subtitle'>
          Accepted file types include PNG, JPG, JPEG.
        </span>
      </StyledGapContainer>
    </StyledUploadButtonContentAttachment>
  );
};

const StyledUploadButtonContentAttachment = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 8px;
  color: ${({ theme }) => theme.palette.text[0]};
  align-items: center;

  .title {
    font-size: 12px;
    line-height: 16px;
    font-weight: 600;
  }

  .subtitle {
    font-size: 10px;
    line-height: 12px;
    color: ${({ theme }) => theme.palette.text[8]};
  }
`;
